__turbopack_context__.v({
  "body": "zY-uBa_body",
  "close": "zY-uBa_close",
  "content": "zY-uBa_content",
  "header": "zY-uBa_header",
  "overlay": "zY-uBa_overlay",
  "root": "zY-uBa_root",
  "title": "zY-uBa_title",
});
